export { default as FormsCursosGrid} from './ListadoEjercicios';
export { default as DetalleFormulario} from './DetalleEjercicio';
export { default as RecuperacionesAdmin} from './Recuperaciones';
export { default as CambioProfesor} from './CambioProfe';
export { default as DetalleClase} from './DetalleClase';
